import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_CreateIncomeForm = _resolveComponent("CreateIncomeForm")!
  const _component_CreateIncomeCategoryModal = _resolveComponent("CreateIncomeCategoryModal")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, { pageTitle: "create_income" }),
      _createVNode(_component_CreateIncomeForm, {
        referenceno: _ctx.referenceno,
        date: _ctx.date,
        categories: _ctx.categories,
        warehouses: _ctx.warehouses,
        form: _ctx.form,
        "is-loading": _ctx.isLoading,
        "is-edit-mode": _ctx.isEditMode,
        "onUpdate:referenceno": _cache[0] || (_cache[0] = ($event: any) => (_ctx.referenceno = $event)),
        "onUpdate:date": _cache[1] || (_cache[1] = ($event: any) => (_ctx.date = $event)),
        "onUpdate:field": _cache[2] || (_cache[2] = (field, value) => _ctx.form[field] = value),
        onGenerateReference: _ctx.fetchNextRef,
        onOpenCategoryModal: _ctx.openCategoryModal,
        onSubmit: _ctx.submitIncome
      }, null, 8, ["referenceno", "date", "categories", "warehouses", "form", "is-loading", "is-edit-mode", "onGenerateReference", "onOpenCategoryModal", "onSubmit"]),
      _createVNode(_component_CreateIncomeCategoryModal, {
        form: _ctx.categoryForm,
        loading: _ctx.isCategorySaving,
        "is-edit-mode": _ctx.isCategoryEditMode,
        onUpdateField: _ctx.updateCategoryField,
        onGenerateCode: _ctx.generateCategoryCode,
        onSubmit: _ctx.submitCategory
      }, null, 8, ["form", "loading", "is-edit-mode", "onUpdateField", "onGenerateCode", "onSubmit"]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ])
  ], 64))
}